import React, {useState, useEffect, useRef} from "react";
import Menu from "../../../../components/layout/menu/index";
import UploadDocumentButton from "../../../../components/shared/uploadDocument";
import DownloadDocumentButton from "../../../../components/shared/downloadDocument";
import {sendConfirmEvaluation, downloadEvaluationTemplate, downloadLastEvaluations, getLastEvaluations, uploadEvaluationsExcel, softDeletePreEvaluations,searchSuppliersByCode, searchSuppliersByName } from "../../../../client/evaluationProvider/index"
import SaveButton from "../../../../components/forms/saveButton";
import CancelButton from "../../../../components/forms/cancelButton";
import { useTable } from "react-table";
import ContentLoader from 'react-content-loader';
import SimpleBar from "simplebar-react";
import 'simplebar-react/dist/simplebar.min.css';
import UploadDocument from "../../../../components/shared/modals/modalDocument/uploadDocument";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ResetFilters from "../../../../components/filters/resetFilters";
import '../../../../../src/index.css'; 
import ModalAlert from "../../../../components/shared/modals/evaluations/modalAlert";
import DateRangeFilter from "../../../../components/filters/dateRangeFilter";
import '../../../../index.css';
import Pagination from "../../../../components/shared/pagination";
import {getSuppliers} from "../../../../client/suppliers/index"
import AsyncSelect from 'react-select/async';

const useOutsideClick = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isDatePickerElement = event.target.closest('.MuiPickersPopper-root') || 
                                 event.target.closest('.MuiPaper-root') || 
                                 event.target.closest('.MuiPickersDay-root');
      
      const isFilterButton = event.target.closest('button')?.textContent === 'Filtros';
      
      if (ref.current && !ref.current.contains(event.target) && !isDatePickerElement) {
        if (!isFilterButton) {
          callback();
        }
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback]);
};

export default function EvaluationAdmin() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [isLoading, setIsLoading] = useState(true);

  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false);
  const [isDownloadingEvaluations, setIsDownloadingEvaluations] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const [file, setFile] = useState(null);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [activeCategoryTab, setActiveCategoryTab] = useState(0);

  const [showFilters, setShowFilters] = useState(false);

  const [selectedCodes, setSelectedCodes] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);

  const [currentAlert, setCurrentAlert] = useState(null);
  const [showAlertModal, setShowAlertModal] = useState(false);

  const [previewData, setPreviewData] = useState([]);
  
  const [tableData, setTableData] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);

  const [evaluationIds, setEvaluationIds] = useState([]);

  const [evaluationsWithObs, setEvaluationsWithObs] = useState([]);
  const [evaluationsWithoutObs, setEvaluationsWithoutObs] = useState([]);

  const [allSupplierCodes, setAllSupplierCodes] = useState([]);
  const [allSupplierNames, setAllSupplierNames] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [currentCategoryId, setCurrentCategoryId] = useState(1);

  const [isConfirming, setIsConfirming] = useState(false); 

  const [isLoadingCodes, setIsLoadingCodes] = useState(false);
  const [isLoadingNames, setIsLoadingNames] = useState(false);

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null
  });

  const filtersRef = useRef(null);
  useOutsideClick(filtersRef, () => {
    if (showFilters) setShowFilters(false);
  });


  const handleCloseAlert = () => {
    setShowAlertModal(false);
  };

  
useEffect(() => {
  const loadSuppliers = async () => {
    try {
      const response = await getSuppliers();
      const suppliersData = response.data || [];
      
      const codes = [];
      const names = [];
      const seenCodes = new Set();
      const seenNames = new Set();
      
      suppliersData.forEach(supplier => {
        if (!seenCodes.has(supplier.code)) {
          seenCodes.add(supplier.code);
          codes.push({
            value: supplier.code,
            label: supplier.code,
            code: supplier.code,
            name: supplier.name
          });
        }
        
        if (!seenNames.has(supplier.name)) {
          seenNames.add(supplier.name);
          names.push({
            value: supplier.name,
            label: supplier.name,
            code: supplier.code,
            name: supplier.name
          });
        }
      });
      
      setAllSupplierCodes(codes);
      setAllSupplierNames(names);
    } catch (error) {
      console.error('Error loading suppliers:', error);
    }
  };

  loadSuppliers();
}, []);

const loadCodeOptions = (inputValue, callback) => {
  if (!inputValue) {
    const limitedOptions = allSupplierCodes.slice(0, 20).map(supplier => ({
      value: supplier.code,
      label: `${supplier.code} - ${supplier.name}`,
      code: supplier.code,
      name: supplier.name
    }));
    callback(limitedOptions);
    return;
  }
  
  if (inputValue.length < 2) {
    callback([]);
    return;
  }

  setIsLoadingCodes(true);  
  
  searchSuppliersByCode(inputValue, 20)
    .then(response => {
      const options = response.data.map(supplier => ({
        value: supplier.code,
        label: `${supplier.code} - ${supplier.name}`,
        code: supplier.code,
        name: supplier.name
      }));
      callback(options);
    })
    .catch(error => {
      console.error('Error searching codes:', error);
      callback([]);
    })
    .finally(() => {
      setIsLoadingCodes(false);  
    });

};

const loadNameOptions = (inputValue, callback) => {
  if (!inputValue) {
    const limitedOptions = allSupplierNames.slice(0, 20).map(supplier => ({
      value: supplier.name,
      label: `${supplier.code} - ${supplier.name}`,
      code: supplier.code,
      name: supplier.name
    }));
    callback(limitedOptions);
    return;
  }
  
  if (inputValue.length < 2) {
    callback([]);
    return;
  }
  
  setIsLoadingNames(true);  

  searchSuppliersByName(inputValue, 20)
    .then(response => {
      const options = response.data.map(supplier => ({
        value: supplier.name,
        label: `${supplier.code} - ${supplier.name}`,
        code: supplier.code,
        name: supplier.name
      }));
      callback(options);
    })
    .catch(error => {
      console.error('Error searching names:', error);
      callback([]);
    })
    .finally(() => {
      setIsLoadingNames(false);  
    });
};

  const applyFilters = async () => {
    try {
      setIsLoading(true);
      setShowFilters(false);
      setCurrentPage(1);
      
    await loadData(1, pageSize, currentCategoryId, true);


    } catch (error) {
      console.error('Error applying filters:', error);
    } finally {
      setIsLoading(false);
    }
  };

const resetFilters = async (categoryId = currentCategoryId) => {
  
  setSelectedCodes([]);
  setSelectedNames([]);
  setDateRange({ startDate: null, endDate: null });
  setCurrentPage(1);
  
  const targetCategoryId = typeof categoryId === 'object' ? currentCategoryId : categoryId;
  await loadData(1, pageSize, targetCategoryId, false); 
};
  
  const loadData = async (page = currentPage, size = pageSize, categoryId = currentCategoryId, useFilters = false) => {
    try {
      setIsLoading(true);

    let codes = [];
    let names = [];
    let startDate = null;
    let endDate = null;

    if (useFilters) {
      codes = selectedCodes.map(option => option.code);
      names = selectedNames.map(option => option.name);
      startDate = dateRange.startDate;
      endDate = dateRange.endDate;
    }

    const evaluationsResponse = await getLastEvaluations(
      codes, names, startDate, endDate, categoryId, page, size
    );
      const responseData = evaluationsResponse.data;
      

      setCurrentPage(responseData.currentPage);
      setTotalPages(responseData.totalPages);
      setTotalRecords(responseData.totalSuppliers);
      
      const tableData = transformDataToTableFormat(
        responseData.result, 
        responseData.allCriteria,
        page,
        size, 
        useFilters
      );
      setTableData(tableData);
      
    } catch (error) {
      console.error('Error fetching data:', error);
      setTableData([]); 
    } finally {
      setIsLoading(false);
    }
  };

useEffect(() => {
  setCurrentPage(1); 
  const hasFilters = selectedCodes.length > 0 || selectedNames.length > 0 || dateRange.startDate || dateRange.endDate;
  loadData(1, pageSize, currentCategoryId, hasFilters);
}, [currentCategoryId]);

const changePage = (page) => {
  setCurrentPage(page);
  const hasFilters = selectedCodes.length > 0 || selectedNames.length > 0 || dateRange.startDate || dateRange.endDate;
  loadData(page, pageSize, currentCategoryId, hasFilters);
};
const handleRecordsCountChange = (event) => {
  const newSize = parseInt(event.target.value);
  setPageSize(newSize);
  setCurrentPage(1); 
  const hasFilters = selectedCodes.length > 0 || selectedNames.length > 0 || dateRange.startDate || dateRange.endDate;
  loadData(1, newSize, currentCategoryId, hasFilters);
};

const transformDataToTableFormat = (resultData, allCriteria = [], currentPage = 1, pageSize = 10, isFiltered = false) => {
  if (!resultData || !Array.isArray(allCriteria)) {
    console.error('Datos no válidos:', { resultData, allCriteria });
    return [];
  }

  const categoryData = {
    categoryId: resultData.categoryId,
    categoryName: resultData.categoryName,
    suppliers: resultData.suppliers || []
  };

  if (isFiltered) {
    const hasEvaluations = categoryData.suppliers.some(supplier => supplier.evaluation !== null);
    
    if (!hasEvaluations) {
      return [];
    }
  }

  const criteriaMap = {};
  allCriteria.forEach(criterion => {
    criteriaMap[criterion.name] = criterion.weight;
  });

  const supplierColumns = [
    { 
      Header: "#",
      accessor: "index",
      minWidth: '50px',
      id: 'index_col',
      Cell: ({ value }) => (
      <span>{value}</span>
      )
    },
    { 
      Header: "Código de proveedor",
      accessor: "Código de proveedor",
      minWidth: '100px',
      id: 'code_col',
      Cell: ({ value }) => <span className="break-words">{value}</span>
    },
    { 
      Header: "Proveedor",
      accessor: "Proveedor",
      minWidth: '250px',
      id: 'supp_col',
    },
    { 
      Header: "Nota Final", 
      accessor: "Nota Final", 
      minWidth: '120px', 
      id: 'final_score',
      Cell: ({ value }) => (
        <span className="break-words font-itcbold">{value}</span>
      )
    },
    { 
      Header: "Fecha de la última evaluación",
      accessor: "Fecha de la última evaluación",
      minWidth: '120px',
      id: 'date_col',
      Cell: ({ value }) => (
        <span className="break-words">{value}</span>
      )
    }
  ];

  const criteriaColumns = Object.entries(criteriaMap).map(([name, weight]) => ({
    Header: `${name} (${weight}%)`,
    accessor: name,
    minWidth: '150px',
    id: `crit_${name}`
  }));

  const columns = [
    ...supplierColumns,
    ...criteriaColumns,
    { Header: "Análisis", accessor: "Análisis", minWidth: '180px', id: 'analysis' },
    { Header: "Recomendaciones", accessor: "Recomendaciones", minWidth: '180px', id: 'recommendations' },
  ];

  const data = categoryData.suppliers.map((supplier, index) => {
      const globalIndex = (currentPage - 1) * pageSize + index;
      const rowData = {
        "index": globalIndex +1,
        "Proveedor": supplier.name,
        "Código de proveedor": supplier.code || " ", 
        "Fecha de la última evaluación": supplier.evaluation?.created_At 
          ? new Date(supplier.evaluation.created_At).toLocaleDateString() 
          : " ", 
        "Análisis": supplier.evaluation?.analysis || " ",
        "Recomendaciones": supplier.evaluation?.recommendations || " ",
        "Nota Final": supplier.evaluation ? `${supplier.evaluation.final_score}%` : " ",
        "evaluationId": supplier.evaluation?.id
      };

      if (supplier.evaluation) {
        supplier.evaluation.details.forEach(detail => {
          rowData[detail.criterionName] = detail.score === 0 ? " " : `${detail.score}%`;
        });
      }

      Object.keys(criteriaMap).forEach(criterion => {
        if (!(criterion in rowData)) {
          rowData[criterion] = " ";
        }
      });

      return rowData;
    });

  return [{
    categoryId: categoryData.categoryId,
    category: categoryData.categoryName,
    data,
    columns
  }];
};

  const handleDownloadTemplate = async () => {
    setIsDownloadingTemplate(true);
    try {
      await downloadEvaluationTemplate();
    } catch (error) {
      console.error('Error al descargar la plantilla:', error);
    } finally {
      setIsDownloadingTemplate(false);
    }
  };

const handleFileProcessed = async (processedData, uploadedFile) => {

  const fileExtension = uploadedFile.name.split('.').pop().toLowerCase();
  const validExtensions = ['xlsx', 'xls'];
  
  if (!validExtensions.includes(fileExtension)) {
    setCurrentAlert({
      title: "Formato de archivo no válido",
      description: `El archivo "${uploadedFile.name}" no es un archivo Excel válido. Por favor, suba un archivo con extensión .xlsx o .xls.`,
      type: 'error'
    });
    setShowAlertModal(true);
    setShowUploadModal(false);
    return;
  }
  
  setFile(uploadedFile);
  setIsUploading(true);
  
  try {
    const response = await uploadEvaluationsExcel(uploadedFile);

    if (response.data.missingCriteria && response.data.missingCriteria.length > 0) {
      const errorDescription = `Los siguientes criterios no existen en la base de datos:\n\n${response.data.missingCriteria.join('\n')}\n\nCorrija los criterios e intente nuevamente.`;
      
      setCurrentAlert({
        title: "Error en criterios",
        description: errorDescription,
        type: 'error'
      });
      setShowAlertModal(true);
      return; 
    }

    if (response.data.validations) {
      const hasErrors = 
        (response.data.validations.invalidCodes && response.data.validations.invalidCodes.length > 0) ||
        (response.data.validations.invalidScores && response.data.validations.invalidScores.length > 0) ||
        (response.data.validations.missingFinalScores && response.data.validations.missingFinalScores.length > 0) ||
        (response.data.validations.duplicateCodes && response.data.validations.duplicateCodes.length > 0) ||
        (response.data.validations.scoreDiscrepancies && response.data.validations.scoreDiscrepancies.length > 0);

      if (hasErrors) {
        let errorDescription = "Se encontraron los siguientes errores:\n\n";
        
        if (response.data.validations.invalidCodes?.length > 0) {
          errorDescription += `- Códigos inválidos: ${response.data.validations.invalidCodes.length} proveedor(es) no existen en el sistema\n`;
          response.data.validations.invalidCodes.forEach(item => {
            errorDescription += `  • Código: ${item.codigo} - Hoja: ${item.hoja} - Fila: ${item.fila}\n`;
          });
        }
        
        if (response.data.validations.invalidScores?.length > 0) {
          errorDescription += `- Puntajes inválidos: ${response.data.validations.invalidScores.length} puntaje(s) mayor(es) a 100%\n`;
        }
        
        if (response.data.validations.missingFinalScores?.length > 0) {
          errorDescription += `- Faltan puntajes finales: ${response.data.validations.missingFinalScores.length} fila(s)\n`;
        }
        
        if (response.data.validations.duplicateCodes?.length > 0) {
          errorDescription += `- Códigos duplicados: ${response.data.validations.duplicateCodes.length} código(s) repetido(s)\n`;
        }
        
        if (response.data.validations.scoreDiscrepancies?.length > 0) {
          errorDescription += `- Discrepancias en puntajes: ${response.data.validations.scoreDiscrepancies.length} discrepancia(s)\n`;
        }

        setCurrentAlert({
          title: "Se encontraron errores",
          description: errorDescription,
          type: 'warning',
          warningMessage: response.data.warningMessage || response.data.message || '',
          excelData: response.data.validations?.excel
        });
        setShowAlertModal(true);
        return; 
      }
    }

    
    const categoriesData = response.data.evaluations || [];
    
    const tableData = transformApiDataToTableFormat(categoriesData);
    setPreviewData(tableData);

    const withObsIds = response.data.evaluationsWithObservations || [];
    const withoutObsIds = response.data.evaluationsWithoutObservations || [];
    

    setEvaluationsWithObs(withObsIds);
    setEvaluationsWithoutObs(withoutObsIds);

    if (tableData.length > 0) {
      setShowPreview(true);
    }
    
  } catch (error) {
    console.error('Error al subir el archivo:', error);
    
    if (error.response?.data) {
      const errorData = error.response.data;
      
      if (errorData.validations) {
        const hasErrors = 
          (errorData.validations.invalidCodes && errorData.validations.invalidCodes.length > 0) ||
          (errorData.validations.invalidScores && errorData.validations.invalidScores.length > 0) ||
          (errorData.validations.missingFinalScores && errorData.validations.missingFinalScores.length > 0) ||
          (errorData.validations.duplicateCodes && errorData.validations.duplicateCodes.length > 0) ||
        (errorData.validations.scoreDiscrepancies && errorData.validations.scoreDiscrepancies.length > 0);

        if (hasErrors) {
          let errorDescription = "Se encontraron los siguientes errores:\n\n";
          
          if (errorData.validations.invalidCodes?.length > 0) {
            errorDescription += `- Códigos inválidos: ${errorData.validations.invalidCodes.length} proveedor(es) no existen en el sistema\n`;
          }
          
          if (errorData.validations.invalidScores?.length > 0) {
            errorDescription += `- Puntajes inválidos: ${errorData.validations.invalidScores.length} puntaje(s) mayor(es) a 100%\n`;
          }
          
          if (errorData.validations.missingFinalScores?.length > 0) {
            errorDescription += `- Faltan puntajes finales: ${errorData.validations.missingFinalScores.length} fila(s)\n`;
          }
          
          if (errorData.validations.duplicateCodes?.length > 0) {
            errorDescription += `- Códigos duplicados: ${errorData.validations.duplicateCodes.length} código(s) repetido(s)\n`;
          }

          if (errorData.validations.scoreDiscrepancies?.length > 0) {
            errorDescription += `- Discrepancias en puntajes: ${errorData.validations.scoreDiscrepancies.length} discrepancia(s)\n`;
          }

          setCurrentAlert({
            title: "Error al procesar el archivo",
            description: errorDescription,
            type: 'warning',
            warningMessage: errorData.message || errorData.warningMessage || '',
            excelData: errorData.validations?.excel
          });
          setShowAlertModal(true);
          return;
        }
      }
      
      // Error de criterios faltantes
      if (errorData.missingCriteria) {
        const errorDescription = `Los siguientes criterios no existen en la base de datos:\n\n${errorData.missingCriteria.join('\n')}`;
        
        setCurrentAlert({
          title: "Error en criterios",
          description: errorDescription,
          type: 'error'
        });
        setShowAlertModal(true);
        return;
      }
      
      // Error genérico
      setCurrentAlert({
        title: "Error al procesar el archivo",
        description: errorData.message || "Ocurrió un error al procesar el archivo",
        type: 'error'
      });
      setShowAlertModal(true);
      
    } else {
      // Error de red o sin respuesta
      setCurrentAlert({
        title: "Error de conexión",
        description: "No se pudo conectar con el servidor. Verifique su conexión.",
        type: 'error'
      });
      setShowAlertModal(true);
    }
    
  } finally {
    setIsUploading(false);
    setShowUploadModal(false);
  }
};

  const transformApiDataToTableFormat = (evaluations = []) => {
    if (!Array.isArray(evaluations)) {
      console.error('Evaluations no es un array:', evaluations);
      return [];
    }

    return evaluations.map(categoryData => {
      const supplierColumns = [
        { 
          Header: "#",
          accessor: "index",
          minWidth: '50px',
          id: 'index_col',
          Cell: ({ value }) => (
            <span>{value + 1}</span>
          )
        },
        { Header: "Proveedor",
          accessor: "Proveedor",
          minWidth: '150px',
          id: 'supp_col',
          Cell: ({ value }) => (
          <span className="break-words font-itcbold">{value}</span>
          )
        },


      ];

    const allCriteria = {};
    categoryData.evaluations.forEach(eva => {
      eva.details.forEach(detail => {
        if (!allCriteria[detail.criterion?.name]) {
          allCriteria[detail.criterion?.name] = detail.weight_criterion;
        }
      });
    });

    const criteriaColumns = Object.entries(allCriteria).map(([name, weight]) => ({
      Header: `${name} (${weight}%)`,
      accessor: name,
      minWidth: '150px',
      id: `crit_${name}`
    }));

      const columns = [
        ...supplierColumns,
        ...criteriaColumns,
        { Header: "Análisis", accessor: "Análisis", minWidth: '180px', id: 'analysis' },
        { Header: "Recomendaciones", accessor: "Recomendaciones", minWidth: '180px', id: 'recommendations' },
        { Header: "Nota Final", accessor: "Nota Final", minWidth: '120px', id: 'final_score' },

      ];

      const data = categoryData.evaluations.map((evaluation,index) => {
        const rowData = {
          "index": index,
          "Proveedor": evaluation.supplier,
        "Código": evaluation.supplierCode || " ", 
        "Fecha de la última evaluación": evaluation.createdAt 
          ? new Date(evaluation.createdAt).toLocaleDateString() 
          : " ", 
          "Análisis": evaluation.analysis || " ",
          "Recomendaciones": evaluation.recommendations || " ",
          "Nota Final": `${evaluation.finalScore}%`,
          "evaluationId": evaluation.evaluationId
        };

        evaluation.details.forEach(detail => {
          rowData[detail.criterion?.name] = detail.score === 0 ? " " : `${detail.score}%`;
        });

        return rowData;
      });

      return {
        categoryId: categoryData.categoryId,
        category: categoryData.category,
        data,
        columns
      };
    });
  };

const handleCancelPreview = async () => {
  try {
    const allEvaluationIds = [
      ...evaluationsWithObs.map(e => e.id).filter(id => id), 
      ...evaluationsWithoutObs.map(e => e.id).filter(id => id),
      ...deletedIds.filter(id => id)
    ];


    if (allEvaluationIds.length > 0) {
      await softDeletePreEvaluations(allEvaluationIds);
    } else {
    }
  } catch (error) {
    console.error('Error al cancelar previsualización:', error);
  } finally {
    setShowPreview(false);
    setPreviewData([]);
    setFile(null);
    setEvaluationIds([]);
    setDeletedIds([]);
    setEvaluationsWithObs([]);
    setEvaluationsWithoutObs([]);
  }
};

const handleConfirmUpload = async () => {
  setIsConfirming(true); 

  try {
    if (deletedIds.length > 0) {
      const validDeletedIds = deletedIds.filter(id => id);
      if (validDeletedIds.length > 0) {
        await softDeletePreEvaluations(validDeletedIds);
      }
    }
    
    const evaluationsWithoutObsIds = evaluationsWithoutObs
      .map(e => e.id)
      .filter(id => id);
      
    const evaluationsWithObsIds = evaluationsWithObs
      .map(e => e.id)
      .filter(id => id);

    if (evaluationsWithoutObsIds.length > 0 || evaluationsWithObsIds.length > 0) {
      await sendConfirmEvaluation(evaluationsWithoutObsIds, evaluationsWithObsIds);
    } else {
    }
  
    setShowPreview(false);
    setDeletedIds([]);
    setShowSuccessModal(true);
    await loadData();
    
  } catch (error) {
    console.error('Error al confirmar la carga:', error);
    
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const errorData = JSON.parse(text);
        setCurrentAlert({
          title: "Error al confirmar la carga",
          description: errorData.message || "Ocurrió un error al confirmar la carga de evaluaciones",
          type: 'error'
        });
      } catch {
        setCurrentAlert({
          title: "Error al confirmar la carga",
          description: "Ocurrió un error al confirmar la carga de evaluaciones",
          type: 'error'
        });
      }
    } else {
      setCurrentAlert({
        title: "Error al confirmar la carga",
        description: error.response?.data?.message || "Ocurrió un error al confirmar la carga de evaluaciones",
        type: 'error'
      });
    }
    
    setShowAlertModal(true);
  } finally {
    setIsConfirming(false); 
  }
};

const handleDownloadEvaluations = async () => {
  try {
    setIsDownloadingEvaluations(true);
    
    await downloadLastEvaluations(); 

  } catch (error) {
    console.error('Error al descargar:', error);
    alert(`Error al descargar: ${error.message}`);
  } finally {
    setIsDownloadingEvaluations(false);
  }
};

  const Table = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = useTable({
      columns,
      data,
    });

    const [expandedCells, setExpandedCells] = useState({});
    const [hasOverflow, setHasOverflow] = useState({});
    const cellRefs = useRef({});

    useEffect(() => {
      const checkOverflow = () => {
        const newOverflow = {};
        Object.entries(cellRefs.current).forEach(([cellKey, el]) => {
          if (el) {
            newOverflow[cellKey] = el.scrollHeight > el.clientHeight;
          }
        });
        setHasOverflow(newOverflow);
      };
  
      const timer = setTimeout(checkOverflow, 0);
      
      checkOverflow();
  
      return () => clearTimeout(timer);
    }, [data, expandedCells]);

    const toggleCell = (cellKey) => {
      setExpandedCells(prev => ({
        ...prev,
        [cellKey]: !prev[cellKey]
      }));
    };
  
    return (
      <SimpleBar className="max-w-full max-h-full table-simplebar scroll-container">
        <table {...getTableProps()} className="w-full bg-white border border-collapse table-auto border-[#D9D9D9]">
        <colgroup>
        {columns.map((column, index) => (
            <col key={index} style={{ minWidth: column.minWidth }} />
          ))}
        </colgroup>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()} className="text-[14px] 2xl:text-[19px] h-[57px] leading-tight text-center font-itcbold">
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps()}
                    className="p-5 border border-[#D9D9D9] border-collapse  h-[57px]  bg-white"
                  >
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className="bg-white ">
            {rows.map((row, rowIndex) => {
              prepareRow(row);
              return (
                <tr
                key={rowIndex}
                className="text-[13px] 2xl:text-[18px] border-collapse  bg-white "
                 {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    const isAnalysisCell = cell.column.id === 'analysis' || cell.column.id === 'recommendations';
                    const cellKey = `${rowIndex}_${cell.column.id}`;
                    const isExpanded = expandedCells[cellKey];
                    const hasOverflowCell = hasOverflow[cellKey];
                    const shouldShowButton = isAnalysisCell;
                    return (
                      <td
                        {...cell.getCellProps()}
                        className={`p-4   border border-[#D9D9D9] relative font-itcmedium text-center`}
                      >
                      <div 
                        ref={el => {
                          if (isAnalysisCell) {
                            cellRefs.current[cellKey] = el;
                          }
                        }}
                        className={`${ !isExpanded ? 
                          'h-full overflow-hidden' : 
                          ''}`}
                        style={{
                          display:  !isExpanded ? '-webkit-box' : 'block',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp:  !isExpanded ? 3 : 'unset'
                        }}                    >
                        {cell.render('Cell')}
                      </div>

                      {shouldShowButton &&  (hasOverflowCell || isExpanded) &&  (
                        <button 
                          className="absolute px-1 text-xs bg-white bottom-1 right-1 text-blue"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleCell(cellKey);
                          }}
                        >
                          {isExpanded ? 'Ver menos' : 'Ver más'}
                        </button>
                      )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </SimpleBar>
    );
  };

const TableLoader = () => (
  <ContentLoader 
    speed={2}
    width="100%"
    height={400}
    viewBox="0 0 1200 400"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    className="w-full"
  >
    {/* Encabezado de la tabla dividido en columnas */}
    {/* Columna # */}
    <rect x="0" y="0" rx="4" ry="4" width="50" height="57" />
    {/* Columna Código de proveedor */}
    <rect x="60" y="0" rx="4" ry="4" width="100" height="57" />
    {/* Columna Proveedor */}
    <rect x="170" y="0" rx="4" ry="4" width="200" height="57" />
    {/* Columna Nota Final */}
    <rect x="380" y="0" rx="4" ry="4" width="80" height="57" />
    {/* Columna Fecha de la última evaluación */}
    <rect x="470" y="0" rx="4" ry="4" width="100" height="57" />
    {/* Columnas de criterios (ejemplo para 3 criterios) */}
    <rect x="580" y="0" rx="4" ry="4" width="120" height="57" />
    <rect x="710" y="0" rx="4" ry="4" width="120" height="57" />
    <rect x="840" y="0" rx="4" ry="4" width="120" height="57" />
    {/* Columnas Análisis y Recomendaciones */}
    <rect x="970" y="0" rx="4" ry="4" width="150" height="57" />
    <rect x="1130" y="0" rx="4" ry="4" width="150" height="57" />
    
    {/* Filas de datos */}
    {[0, 1, 2, 3, 4, 5, 6, 7].map((rowIndex) => (
      <React.Fragment key={rowIndex}>
        {/* Columna # */}
        <rect x="0" y={70 + (rowIndex * 45)} rx="4" ry="4" width="50" height="20" />
        {/* Columna Código */}
        <rect x="60" y={70 + (rowIndex * 45)} rx="4" ry="4" width="100" height="20" />
        {/* Columna Proveedor */}
        <rect x="170" y={70 + (rowIndex * 45)} rx="4" ry="4" width="200" height="20" />
        {/* Columna Nota Final */}
        <rect x="380" y={70 + (rowIndex * 45)} rx="4" ry="4" width="80" height="20" />
        {/* Columna Fecha */}
        <rect x="470" y={70 + (rowIndex * 45)} rx="4" ry="4" width="100" height="20" />
        {/* Columnas de criterios (ejemplo para 3 criterios) */}
        <rect x="580" y={70 + (rowIndex * 45)} rx="4" ry="4" width="120" height="20" />
        <rect x="710" y={70 + (rowIndex * 45)} rx="4" ry="4" width="120" height="20" />
        <rect x="840" y={70 + (rowIndex * 45)} rx="4" ry="4" width="120" height="20" />
        {/* Columnas Análisis y Recomendaciones */}
        <rect x="970" y={70 + (rowIndex * 45)} rx="4" ry="4" width="150" height="20" />
        <rect x="1130" y={70 + (rowIndex * 45)} rx="4" ry="4" width="150" height="20" />
      </React.Fragment>
    ))}
  </ContentLoader>
);

  const CategoryTabs = ({ activeTab, onTabChange }) => {
    const categories = [
      { categoryId: 1, categoryName: "Bienes" },
      { categoryId: 2, categoryName: "Servicios" },
      { categoryId: 3, categoryName: "Insumos" }
    ];
    return (
      <div className="flex">
        {categories.map((category, index) => (
          <button
            key={category.categoryId}
            className={`sm:py-[17px] py-2 px-4 sm:px-8 border-b-2 rounded-tl-xl rounded-tr-xl border-blue  font-itcmedium text-lg ${
              currentCategoryId === category.categoryId
                ? ' bg-blue text-white'
                : 'text-blue bg-white'
            }`}
          onClick={() => {
            setCurrentCategoryId(category.categoryId);
            setActiveCategoryTab(index); 
          }}
            >
            {category.categoryName}
          </button>
        ))}
      </div>
    );
  };

  return (
    <div>
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="md:pt-8 pt-4 pb-10 px-[3%] flex flex-col gap-4">
                {showPreview ? (
                  // Pantalla de previsualización
                  <div className="flex flex-col gap-4">
                    <h1 className="text-blue font-itcmedium md:text-[32px] text-2xl">Previsualización de evaluación</h1>
                    <h2 className="font-itcbook  text-xl md:text-2xl text-[#6B7280]">Revise los datos antes de confirmar</h2>
                    {previewData.length > 0 ? (
                      <>
                        <CategoryTabs 
                          categories={previewData} 
                          activeTab={activeCategoryTab}
                          onTabChange={setActiveCategoryTab}
                        />



                        {previewData[activeCategoryTab]?.data?.length > 0 ? (
                          <Table 
                            key={`table-${activeCategoryTab}-${previewData[activeCategoryTab]?.data?.length}`}
                            columns={previewData[activeCategoryTab].columns} 
                            data={previewData[activeCategoryTab].data} 
                          />
                        ) : (
                          <p className="py-10 text-center text-red">
                            No existe evaluaciones de proveedores en esta categoría.
                          </p>
                        )}
                      </>
                    ) : (
                      <p className="py-10 text-center text-red">
                        No existe evaluaciones de proveedores en esta categoría.
                      </p> 
                    )}

                    <div className={`fixed z-10 md:flex-row flex-col gap-2 md:gap-7 transition-all duration-300 flex transform -translate-x-1/2 bottom-4 left-1/2 animate-float
                      ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
                      <SaveButton
                        title={isConfirming ? "Enviando..." : "Enviar"}
                        onClick={handleConfirmUpload}
                        disabled={previewData.length === 0 || isConfirming}
                      />
                      <CancelButton 
                        bg="bg-[#F7F8F9]"
                        disabled={isConfirming}
                        onClick={handleCancelPreview}
                      />
                    </div>
                  </div>
                ) : (
                  <>
                  {/**Visualización */}
                  <div className="flex flex-col items-center justify-between gap-2 md:flex-row">
                      <h1 className="text-blue font-itcmedium md:text-[32px] text-2xl">Evaluación de proveedores</h1>
                      <div className="flex items-center justify-center gap-4">
                          <DownloadDocumentButton
                              text="Descargar Plantilla"
                              onClick={handleDownloadTemplate}
                              loading={isDownloadingTemplate}
                          />
                          <UploadDocumentButton
                                text="Subir documentos"
                                isEnabled={true}
                                onClick={() => setShowUploadModal(true)}
                          />
                      </div>
                  </div>
                  <div className="flex flex-col items-start justify-between gap-2 xl:flex-row ">
                    <h2 className="font-itcbook text-base md:text-2xl text-[#6B7280]">
                      Aquí podrás ver la evaluación de los proveedores según criterio 
                    </h2>
                    <div className="flex items-center justify-end gap-2 md:justify-center">
                      <div className="relative">
                        <button 
                          className={`border-[#5CBDEB] border-[1px] text-[14px] font-itcmedium rounded-lg w-[105px] h-[40px] flex items-center justify-center text-[#52526C]
                           ${
                          dateRange.startDate || dateRange.endDate || selectedCodes.length > 0 || selectedNames.length > 0
                            ? "bg-blue-light text-white"
                            : "text-[#52526C]"
                           } `}
                          onClick={(e) => {
                            e.stopPropagation(); 
                            setShowFilters(!showFilters);
                          }}
                        >
                          Filtros
                        </button>
                        {showFilters && (
                          <div 
                            ref = {filtersRef}
                            onClick={(e) => e.stopPropagation()} 
                            className="absolute -bottom-2 left-0 xl:left-auto xl:right-0 mt-2 transform translate-y-full bg-white rounded-lg w-[266px] sm:w-[386px] p-4 py-5 shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026] z-10 h-[300px] sm:h-auto overflow-y-auto">
                            <p className="text-base text-blue font-itcbold">Filtrar por</p>
                            <div className="bg-[#D9D9D9] h-[1px] my-2 w-full"></div>
                            <div className="my-4">
                              <label className="text-base text-blue font-itcbook">Buscar proveedor por código:</label>
                              <AsyncSelect
                                isMulti
                                isDisabled={isLoading}
                                isLoading={isLoadingCodes}  
                                cacheOptions
                                defaultOptions
                                loadOptions={loadCodeOptions}
                                value={selectedCodes}
                                onChange={setSelectedCodes}
                                getOptionLabel={option => option.code}
                                getOptionValue={option => option.code}
                                placeholder="Seleccione proveedores"
                                className="mt-1 text-sm font-itcbook"
                                loadingMessage={() => "Cargando..."}
                                noOptionsMessage={({ inputValue }) => 
                                  inputValue.length < 2 ? 
                                  "Escriba al menos 2 caracteres..." : 
                                  "No se encontraron opciones"
                                }
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    minHeight: '40px',
                                    maxHeight: '120px',
                                    overflow: 'auto',
                                    borderColor: '#D1D5DB',
                                    '&:hover': {
                                      borderColor: '#D1D5DB',
                                    },
                                    boxShadow: state.isFocused ? 'none' : base.boxShadow,
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    zIndex: 9999
                                  })
                                }}
                              />
                            </div>
                            
                            <div className="my-4">
                              <label className="text-base text-blue font-itcbook">Buscar proveedor por razón social:</label>
                              <AsyncSelect
                                isMulti
                                isDisabled={isLoading}
                                isLoading={isLoadingNames}
                                cacheOptions
                                defaultOptions
                                loadOptions={loadNameOptions}
                                value={selectedNames}
                                onChange={setSelectedNames}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.name}
                                placeholder="Seleccione proveedores"
                                className="mt-1 text-sm font-itcbook"
                                loadingMessage={() => "Cargando..."}
                                noOptionsMessage={({ inputValue }) => 
                                  inputValue.length < 2 ? 
                                  "Escriba al menos 2 caracteres..." : 
                                  "No se encontraron opciones"
                                }
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    minHeight: '40px',
                                    maxHeight: '120px',
                                    overflow: 'auto',
                                    borderColor: '#D1D5DB',
                                    '&:hover': {
                                      borderColor: '#D1D5DB',
                                    },
                                    boxShadow: state.isFocused ? 'none' : base.boxShadow,
                                  }),
                                  menu: provided => ({
                                    ...provided,
                                    zIndex: 9999
                                  })
                                }}
                              />
                            </div>

                            <div className="my-4">
                              <label className="text-base text-blue font-itcbook">Buscar por fecha de última evaluación:</label>
                              <DateRangeFilter 
                                onDateRangeChange={(range) => setDateRange(range)} 
                                value={dateRange}
                              />
                            </div>
                            <div className="flex justify-center w-full">
                              <button onClick={applyFilters} className="underline text-blue font-itcbold">Aplicar</button>
                            </div>
                          </div>
                        )}
                      </div>
                      <ResetFilters
                      onClick={resetFilters}
                      borderColor="border-[#5CBDEB]"
                      textColor="text-[#52526C]"/>
                    </div>
                  </div>

                    <CategoryTabs 
                      activeTab={activeCategoryTab}
                      onTabChange={setActiveCategoryTab}
                    />
                  {isLoading || isUploading ? (
                    <TableLoader />
                  ) : tableData.length > 0 && tableData[0].data.length > 0 ? (
                    <> 
                      
                        <div className="flex items-start justify-between gap-2 ">
                          <div className="flex items-center space-x-2 text-sm font-itcbook">
                            <p >Mostrar</p>
                            <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                              <select
                                className="w-full h-full px-2 text-sm bg-white rounded-md outline-none cursor-pointer font-itcbook"
                                value={pageSize}
                                onChange={handleRecordsCountChange}  
                              >
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                              </select>
                            </div>
                            <p >Registros</p>
                          </div>
                        </div>
                        <Table 
                          columns={tableData[0].columns} 
                          data={tableData[0].data} 
                        />
                        <Pagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          changePage={changePage}
                          recordsPerPage={pageSize}
                          totalRecords={totalRecords}
                        />
                      
                    <div className={`fixed z-10  transform -translate-x-1/2 bottom-4 left-1/2 animate-float
                      ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
                      <button
                        onClick={handleDownloadEvaluations}
                        disabled={isDownloadingEvaluations}
                        className="bg-[#184A7D] w-[246px] text-white rounded-2xl flex items-center justify-center p-4 font-itcdemi text-[13px] md:text-[18px] shadow-lg hover:bg-[#133a63] transition-colors"
                      >
                        {isDownloadingEvaluations ? (
                          <>
                            <span>Descargando</span>
                            <div className="w-4 h-4 ml-2 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
                          </>
                        ) : (
                          "Descargar evaluaciones"
                        )}
                      </button>
                    </div>
                    </>
                  ) : (
                <div className="text-center font-itcmedium py-28 text-red">
                  {totalRecords > 0 ? "No existen proveedores con evaluación en esta categoría" : "No se encontraron evaluaciones."}
                </div>  
                )}
                  </>
                )}
            </div>
        </div>
        <UploadDocument
          showModalUploadDocument={showUploadModal}
          closeModal={() => setShowUploadModal(false)}
          onFileProcessed={handleFileProcessed}
          fieldMapping={{
            "#": "#",
            "Criterios": "Criterio",
          }}
          strictMapping={false}
        />

        <ModalSuccess 
          showModalSuccess={showSuccessModal}
          closeModalSuccess={() => setShowSuccessModal(false)}
          fill="green"
          text="Sus evaluaciones fueron registradas con éxito!"
        />

        <ModalAlert 
          showModalAlert={showAlertModal}
          closeModal={handleCloseAlert}
          accept={handleCloseAlert}
          title={currentAlert?.title || ''}
          description={currentAlert?.description || ''}
          excelData={currentAlert?.type === 'warning' ? currentAlert?.excelData : null} 
          warningMessage={currentAlert?.warningMessage || ''}
        />
    </div>
  )
}